// Pins (brands) / flags (attributes) for the BPM TV topographic surface.
// Port of BrandPerceptialMapping.Tv.ChartView `createPinsFlags` / `setBrandsVisibility` /
// `setAttributesVisibility` (bpm/tv/chart.coffee). Pure — no DOM, no rendering.

import { noTextPlaceholder, removeLogicFromText } from '@aytm/app/stats/page/components/lib/utils'
import { decodeText } from '@aytm/app/stats/lib/util/helpers'

// strip ALL html tags → removeLogicFromText → noTextPlaceholder fallback → decode entities
// (legacy createPinsFlags text pipeline, kept 1:1). SVG text draws no markup, so every label and
// title this surface writes reads its text through here; with no element there is no placeholder.
export const calcPlainText = (raw, fallbackEl) =>
  decodeText(
    removeLogicFromText(String(raw ?? '').replace(/(<([^>]+)>)/gi, '')) ||
      (fallbackEl ? noTextPlaceholder(fallbackEl) : '')
  )

// Brand pins: grid coords from geoData.pins.brandX/brandY, theme color per index, id = position.
export const computePins = ({ answer, questionVariants = [], colorTheme = [] }) => {
  const pinsGeo = answer?.mds?.geoData?.pins
  const brandX = pinsGeo?.brandX || []
  const brandY = pinsGeo?.brandY || []

  return brandX.map((x, i) => {
    const brand = questionVariants[i]
    return {
      x,
      y: brandY[i],
      text: calcPlainText(brand.text, brand),
      color: colorTheme[i],
      questionVariantId: brand.position
    }
  })
}

// Attribute flags: grid coords from geoData.pins.attrX/attrY, id = position.
export const computeFlags = ({ answer, batches = [] }) => {
  const pinsGeo = answer?.mds?.geoData?.pins
  const attrX = pinsGeo?.attrX || []
  const attrY = pinsGeo?.attrY || []

  return attrX.map((x, i) => {
    const attr = batches[i]
    return {
      x,
      y: attrY[i],
      text: calcPlainText(attr.text, attr),
      branchId: attr.position
    }
  })
}

// pin.label toggles only the text label (marker stays). Partial selection hides the rest.
export const applyBrandsVisibility = (pins, tvBrandsValue = []) => {
  if (tvBrandsValue.length && tvBrandsValue.length !== pins.length) {
    pins.forEach(p => {
      p.label = false
    })
    tvBrandsValue.forEach(qvid => {
      const p = pins.find(pin => `${pin.questionVariantId}` === `${qvid}`)
      if (p) p.label = true
    })
  } else {
    pins.forEach(p => {
      p.label = true
    })
  }
  return pins
}

// flag.hidden removes the attribute flag entirely. Partial selection hides the rest.
export const applyAttributesVisibility = (flags, tvAttributesValue = []) => {
  if (tvAttributesValue.length && tvAttributesValue.length !== flags.length) {
    flags.forEach(f => {
      f.hidden = true
    })
    tvAttributesValue.forEach(bid => {
      const f = flags.find(flag => `${flag.branchId}` === `${bid}`)
      if (f) f.hidden = false
    })
  } else {
    flags.forEach(f => {
      f.hidden = false
    })
  }
  return flags
}
